type CashbackSymbolProps = {
  width?: number
  height?: number
}

export const CashbackSymbol = ({
  width = 18,
  height = 19
}: CashbackSymbolProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1880_11144)">
      <path
        d="M9 1.479V17.5207"
        stroke="#6C0CAE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6458 4.396H7.17708C6.50023 4.396 5.8511 4.66488 5.37249 5.14348C4.89388 5.62209 4.625 6.27122 4.625 6.94808C4.625 7.62493 4.89388 8.27407 5.37249 8.75267C5.8511 9.23128 6.50023 9.50016 7.17708 9.50016H10.8229C11.4998 9.50016 12.1489 9.76904 12.6275 10.2477C13.1061 10.7263 13.375 11.3754 13.375 12.0522C13.375 12.7291 13.1061 13.3782 12.6275 13.8568C12.1489 14.3354 11.4998 14.6043 10.8229 14.6043H4.625"
        stroke="#6C0CAE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1880_11144">
        <rect
          width="17.5"
          height="17.5"
          fill="white"
          transform="translate(0.25 0.75)"
        />
      </clipPath>
    </defs>
  </svg>
)
